import { Helmet } from 'react-helmet-async';

import { getAppSettings } from '~/lib/appSettings';

export type IHotjarProps = Record<string, never>;

export const HotJar: React.FC<IHotjarProps> = () => {
  const appSettings = getAppSettings();
  const hotjarSettings = appSettings.analytics.hotjar;
  if (!hotjarSettings?.enabled) {
    return null;
  }

  return (
    <Helmet>
      <script type="text/javascript" key="hotjar">
        {`(function(h,o,t,j,a,r){
              h.hj=h.hj||function(){(h.hj.q=h.hj.q||[]).push(arguments)};
              h._hjSettings={hjid:${hotjarSettings.siteId},hjsv:6};
              a=o.getElementsByTagName('head')[0];
              r=o.createElement('script');r.async=1;
              r.src=t+h._hjSettings.hjid+j+h._hjSettings.hjsv;
              a.appendChild(r);
            })(window,document,'https://static.hotjar.com/c/hotjar-','.js?sv=');
          `}
      </script>
    </Helmet>
  );
};
